import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const DPContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  
  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  
  '@media only screen and (min-width: 600px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.rowFields': {
      flexDirection: 'row',
    },
  },
})
